import styled from "styled-components"

export const StyledFooter = styled.div`

background: #c33149;
padding: 30px;
position: fixed;
color: #f2f7f2;
width: 100%;
position: fixed;
padding: 10px 20px 20px 10px;
bottom: 0;
width: 100%;
height: 40px;


`


